module.exports = __webpack_public_path__ + "img/mainright.d5bfda6a.png";